export default __webpack_public_path__ + "static/media/Deed of Contract_07.64092139.jpg";